"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _Skeleton = _interopRequireDefault(require("@material-ui/lab/Skeleton"));
var _Skeleton2 = _interopRequireDefault(require("./Skeleton.styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Skeleton = _ref => {
  let {
    isAccordion
  } = _ref;
  const css = (0, _Skeleton2.default)();
  if (isAccordion) return /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: (0, _clsx.default)(css.accordion, "mco-filter-item__accordion-skeleton")
  }, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    height: 52,
    variant: "text",
    width: "100%"
  }));
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: (0, _clsx.default)(css.skeleton, "mco-filter-item__skeleton")
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    mb: 1
  }, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    height: 26,
    variant: "text",
    width: "100%"
  })), /*#__PURE__*/_react.default.createElement(_Box.default, {
    mb: 1
  }, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    height: 40,
    variant: "text",
    width: "100%"
  })), [...Array(6)]?.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement(_Box.default, {
      key: index,
      mb: 1
    }, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
      height: 26,
      variant: "text",
      width: "100%"
    }));
  }));
};
var _default = exports.default = Skeleton;